import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=2a17e08a&"
import script from "./Navigation.ts?vue&type=script&lang=ts&"
export * from "./Navigation.ts?vue&type=script&lang=ts&"
import style0 from "./Navigation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
